import React, { useEffect, useRef, useState } from 'react';
import Header from '../../components/ui/Header';
import Seo from '../../components/Seo';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import Button from '../../components/ui/Button';

const USWaitlistPage = () => {
  const [form, setForm] = useState({ name: '', email: '', businessType: 'Freelancer', consent: false });
  const [hp, setHp] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const mountedAtRef = useRef(Date.now());

  useEffect(() => {
    mountedAtRef.current = Date.now();
    try { window?.analytics?.track?.('us_waitlist_view', { path: window?.location?.pathname || '', ts: Date.now() }); } catch(_) {}
  }, []);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null); setSuccess(null);

    // anti-bot: min delay
    const elapsed = Date.now() - (mountedAtRef.current || Date.now());
    if (elapsed < 800) {
      setError('Please wait a moment before submitting.');
      return;
    }
    // honeypot
    if (hp && hp.trim().length > 0) {
      return; // silently drop
    }

    setSubmitting(true);
    const endpoint = '/api/waitlist/us';

    try {
      try { window?.analytics?.track?.('us_waitlist_submit', { path: window?.location?.pathname || '', ts: Date.now(), bizType: form.businessType }); } catch(_) {}
      const r = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ ...form, region: 'US', source: 'website' })
      });
      const isJson = (r.headers.get('content-type') || '').includes('application/json');
      const j = isJson ? await r.json().catch(() => ({})) : null;
      if (r.ok && (j?.success || j?.ok)) {
        setSuccess({ already: !!j?.already });
        try { window?.analytics?.track?.('us_waitlist_success', { already: !!j?.already, ts: Date.now() }); } catch(_) {}
        setForm({ name: '', email: '', businessType: 'Freelancer', consent: false });
      } else {
        let detail = '';
        try { detail = isJson ? (j?.error || JSON.stringify(j)) : await r.text(); } catch {}
        const msg = `Request failed (${r.status} ${r.statusText || ''})${detail ? ` — ${detail}` : ''}`.trim();
        setError(msg);
        try { window?.analytics?.track?.('us_waitlist_error', { ts: Date.now(), status: r.status, statusText: r.statusText, message: detail || 'unknown', bizType: form.businessType }); } catch(_) {}
      }
    } catch (err) {
      const message = err?.message || 'Please try again.';
      setError(`Network error: ${message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Seo title="U.S. Waitlist — Neevii" description="Join the U.S. waitlist for Neevii’s AI accounting (1040 + Schedule C)." />
      <div className="min-h-screen">
        <Header />
        <main className="pt-36 lg:pt-48 px-6 lg:px-8">
          <div className="max-w-2xl mx-auto">
            <div className="mb-8">
              <h1 className="text-4xl sm:text-5xl font-extrabold mb-2 bg-gradient-to-r from-white via-blue-400 to-purple-400 bg-clip-text text-transparent">U.S. Waitlist</h1>
              <p className="text-base md:text-lg text-muted-foreground">We’re bringing Neevii to the U.S. Join the waitlist for early access.</p>
            </div>
            <div className="mb-6 text-base md:text-lg text-foreground font-semibold">
              First 150 U.S. beta testers — reduced price $12/month + full Pro features for 3 months.
            </div>
            <form onSubmit={onSubmit} className="bg-card border border-border rounded-2xl p-6 space-y-4">
              {/* Honeypot */}
              <input type="text" name="hp" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" tabIndex={-1} autoComplete="off" />
              <Input
                label="Name"
                name="name"
                value={form.name}
                onChange={onChange}
                required
                placeholder="Jane Doe"
              />
              <Input
                type="email"
                label="Email"
                name="email"
                value={form.email}
                onChange={onChange}
                required
                placeholder="jane@example.com"
              />
              <Select
                label="Business type"
                name="businessType"
                value={form.businessType}
                onChange={(v) => setForm((f) => ({ ...f, businessType: v }))}
                options={[
                  { label: 'Freelancer', value: 'Freelancer' },
                  { label: 'LLC', value: 'LLC' },
                  { label: 'Accountant', value: 'Accountant' },
                ]}
              />
              <div className="flex items-center gap-2">
                <Input type="checkbox" name="consent" checked={form.consent} onChange={onChange} />
                <span className="text-sm text-muted-foreground">Notify me about beta and early partner offers.</span>
              </div>
              {error && (<div role="alert" className="text-sm text-destructive">{error}</div>)}
              {success && (
                <div role="status" className="text-sm text-green-600">
                  {success.already ? "You're already on the list for the U.S. beta." : "Thanks for joining! We'll email you when the U.S. beta opens."}
                </div>
              )}

              <div className="pt-2">
                <Button type="submit" variant="default" disabled={submitting} fullWidth>
                  {submitting ? 'Submitting…' : 'Join Waitlist'}
                </Button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </>
  );
};

export default USWaitlistPage;









